import { SettingsMenuEnum } from 'modules/profile/enums/settings-menu-enum'
import { pageRoute, type PageRouteValue } from 'shared/constants/routes.constants'

export const settingsMenuHref: Record<SettingsMenuEnum, PageRouteValue> = {
  [SettingsMenuEnum.profile]: pageRoute.ProfileUserSettings,
  [SettingsMenuEnum.account]: pageRoute.ProfileAccountSettings,
  [SettingsMenuEnum.my_plan]: pageRoute.ProfileUserPlan,
  [SettingsMenuEnum.payment_gateways]: pageRoute.ProfilePaymentGateways,
  [SettingsMenuEnum.manage_subscriptions]: pageRoute.ProfileManageSubscriptions,
  [SettingsMenuEnum.mailing]: pageRoute.ProfileMailingSettings,
  [SettingsMenuEnum.membership]: pageRoute.ProfileCourseSettings,
  [SettingsMenuEnum.payment_page]: pageRoute.ProfilePaymentSettings,
  [SettingsMenuEnum.sales_funnel]: pageRoute.ProfileSalesFunnelsSettings,
  [SettingsMenuEnum.shipping]: pageRoute.ProfileShippingSettings,
  [SettingsMenuEnum.affiliate_program]: pageRoute.ProfileAffiliateProgramSettings,
  [SettingsMenuEnum.custom_domains]: pageRoute.ProfileCustomDomainsSettings,
  [SettingsMenuEnum.public_api]: pageRoute.ProfilePublicApiSettings,
  [SettingsMenuEnum.webhooks]: pageRoute.ProfileWebhookSettings,
  [SettingsMenuEnum.integrations]: pageRoute.ProfileIntegrations,
  [SettingsMenuEnum.affiliate_commissions]: pageRoute.ProfileAffiliateSettings,
  [SettingsMenuEnum.notification]: pageRoute.ProfileNotificationSettings,
  [SettingsMenuEnum.workspace_members]: pageRoute.ProfileWorkspaceMembers,
  [SettingsMenuEnum.change_password]: pageRoute.ProfileChangePassword,
}
